import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadBillingRequest: [''],
  loadBillingSuccess: ['billing'],
  loadBillingFailure: ['error'],

  loadNewOlsBillingRequest: [''],
  loadNewOlsBillingSuccess: ['newOlsbilling'],
  loadNewOlsBillingFailure: ['error'],

  loadPrimaryCardRequest: [''],
  loadPrimaryCardSuccess: ['primaryCardDetails'],
  loadPrimaryCardFailure: ['error'],

  makePrimaryRequest: ['payload'],
  makePrimarySuccess: [''],
  makePrimaryFailure: ['error'],

  makePaymentRequest: ['payload'],
  makePaymentSuccess: ['paymentDetails'],
  makePaymentFailure: ['error'],

  saveCardInfoRequest: ['payload'],
  saveCardInfoSuccess: ['cardInfo'],
  saveCardInfoFailure: ['error'],

  addNewCardRequest: ['payload'],
  addNewCardSuccess: [''],
  addNewCardFailure: ['error'],

  deleteCardRequest: ['payload'],
  deleteCardSuccess: [''],
  deleteCardFailure: ['error'],

  paymentReset: ['paymentReset'],

  loadBillingUrlRequest: ['payload'],
  loadBillingUrlSuccess: ['url'],
  loadBillingUrlFailure: ['error'],

  addCreditCardRequest: ['card'],
  addCreditCardSuccess: ['creditCardInfo'],
  addCreditCardFailure: ['error'],
});

const billingActions = {
  Types,
  Creators,
};

export default billingActions;
